import React from "react";
import { Link } from "react-router-dom";
import {
  FaCalendarAlt,
  FaUser,
  FaClock,
  FaChevronLeft,
  FaLinkedin,
  FaTwitter,
  FaFacebook,
  FaShieldAlt,
  FaBalanceScale,
  FaExclamationTriangle,
} from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";

const DetailBlog13 = () => {
  const blogPost = {
    id: 12,
    title:
      "Nouvelle loi sur la concurrence au Bénin : le décryptage de votre Expert-Comptable pour protéger et développer votre entreprise",
    excerpt:
      "Une nouvelle ère s'ouvre pour l'environnement des affaires au Bénin. Avec la promulgation de la Loi N° 2025-02 du 05 février 2025, notre pays se dote d'un cadre juridique moderne et complet pour organiser la concurrence.",
    content: `
      <div class="hero-intro">
        <div class="intro-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
        </div>
        <p class="intro-lead">Une nouvelle ère s'ouvre pour l'environnement des affaires au Bénin. Avec la promulgation de la <strong>Loi N° 2025-02 du 05 février 2025</strong>, notre pays se dote d'un cadre juridique moderne et complet pour organiser la concurrence. Cette loi n'est pas qu'un simple texte réglementaire ; elle redéfinit les règles du jeu pour toutes les entreprises, de la plus petite à la plus grande.</p>
        
        <p>En tant qu'expert-comptable, au cœur de la stratégie et de la gestion quotidienne des entreprises, il m'apparaît essentiel de vous en présenter les grands axes. Loin d'être une source de contraintes, cette loi est une opportunité de sécuriser vos pratiques commerciales, de renforcer votre compétitivité et d'opérer dans un marché plus sain et plus juste.</p>
        
        <p class="intro-emphasis">Voyons ensemble ce que tout dirigeant d'entreprise doit savoir.</p>
      </div>
      
      <div class="principe-section">
        <div class="section-header">
          <div class="section-number">01</div>
          <div class="section-title-wrapper">
            <h2>Le Grand Principe : La liberté des prix, mais une liberté Encadrée</h2>
            <div class="section-underline"></div>
          </div>
        </div>
        
        <div class="principe-content">
          <p class="principe-intro">Le principe de base est clair : <strong>les prix des biens et des services sont librement déterminés par le jeu de la concurrence</strong>. C'est une excellente nouvelle pour l'innovation et la compétitivité.</p>
          
          <p>Cependant, cette liberté n'est pas absolue. L'État conserve la possibilité d'intervenir et de réglementer les prix dans des situations bien précises :</p>
          
          <div class="intervention-grid">
            <div class="intervention-card">
              <div class="card-icon strategic">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2L2 7v10c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V7l-10-5z"/>
                </svg>
              </div>
              <h4>Biens & services stratégiques</h4>
              <p>Pour les biens et services stratégiques ou à fort impact social.</p>
            </div>
            
            <div class="intervention-card">
              <div class="card-icon monopole">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"/>
                </svg>
              </div>
              <h4>Situation de Monopole</h4>
              <p>En cas de situation de monopole ou de difficultés durables d'approvisionnement.</p>
            </div>
            
            <div class="intervention-card">
              <div class="card-icon crise">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
                </svg>
              </div>
              <h4>Crise ou situation anormale</h4>
              <p>En cas de crise ou de situation anormale du marché (hausse excessive des prix), où des mesures temporaires peuvent être prises.</p>
            </div>
          </div>
          
          <div class="expert-advice">
            <div class="advice-badge">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
              </svg>
              L'avis de l'expert
            </div>
            <p>Cette régulation implique que les entreprises doivent avoir une structure de coûts parfaitement documentée et justifiable. Une comptabilité analytique précise devient un atout stratégique pour dialoguer avec les autorités en cas de contrôle des prix.</p>
          </div>
        </div>
      </div>
      
      <div class="interdictions-section">
        <div class="section-header danger">
          <div class="section-number">02</div>
          <div class="section-title-wrapper">
            <h2>Les Lignes Rouges à ne pas Franchir : Les Pratiques Absolument Interdites</h2>
            <div class="section-underline danger"></div>
          </div>
        </div>
        
        <div class="interdictions-content">
          <p class="section-intro">La loi est très ferme sur les comportements qui faussent le jeu de la concurrence. Les connaître est essentiel pour éviter des sanctions qui peuvent être très lourdes. Sont formellement interdites:</p>
          
          <div class="interdiction-list">
            <div class="interdiction-item">
              <div class="interdiction-header">
                <div class="interdiction-icon entente">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                  </svg>
                </div>
                <h3>Les Ententes Anti-concurrentielles</h3>
              </div>
              <p>Il est illégal de s'accorder avec ses concurrents pour, par exemple, fixer les prix, se répartir les marchés ou les clients, ou limiter la production. Ces pratiques, souvent appelées "cartels", sont sévèrement punies.</p>
            </div>
            
            <div class="interdiction-item">
              <div class="interdiction-header">
                <div class="interdiction-icon abus">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
                  </svg>
                </div>
                <h3>L'Abus de Position Dominante</h3>
              </div>
              <p>Une entreprise qui détient une part de marché très importante n'a pas le droit d'abuser de sa puissance pour évincer ses concurrents. Cela inclut le fait d'imposer des prix ou des conditions de vente non équitables ou de refuser de vendre sans motif légitime.</p>
            </div>
            
            <div class="interdiction-item">
              <div class="interdiction-header">
                <div class="interdiction-icon deloyale">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
                  </svg>
                </div>
                <h3>La Concurrence Déloyale</h3>
              </div>
              <p>La loi liste de nombreux actes considérés comme déloyaux, parmi lesquels :</p>
              <ul class="deloyale-list">
                <li>La publicité mensongère ou trompeuse</li>
                <li>Le dénigrement : jeter le discrédit sur un concurrent ou ses produits</li>
                <li>La confusion : imiter les signes distinctifs d'un concurrent (nom, marque, enseigne) pour tromper la clientèle</li>
                <li>La contrefaçon</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      
      <div class="transparence-section">
        <div class="section-header">
          <div class="section-number">03</div>
          <div class="section-title-wrapper">
            <h2>La Transparence, Pilier de la Confiance : Vos Obligations au Quotidien</h2>
            <div class="section-underline"></div>
          </div>
        </div>
        
        <div class="transparence-content">
          <p class="section-intro">Pour assurer un jeu concurrentiel loyal, la loi renforce les obligations de transparence. Ces règles impactent directement votre gestion administrative et commerciale.</p>
          
          <div class="obligations-grid">
            <div class="obligation-card">
              <div class="obligation-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
                </svg>
              </div>
              <h4>Facturation Rigoureuse</h4>
              <p>Tout vendeur ou prestataire de services doit émettre une facture conforme pour chaque opération. L'acheteur, quant à lui, est en droit de la réclamer.</p>
            </div>
            
            <div class="obligation-card highlight">
              <div class="obligation-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"/>
                </svg>
              </div>
              <h4>Conservation des Documents</h4>
              <p><strong>Attention, un point crucial souvent négligé !</strong> Les factures (originaux et copies) doivent être conservées pendant au moins <strong>dix (10) ans</strong> par les deux parties. La destruction ou la modification frauduleuse de ces documents est interdite.</p>
            </div>
            
            <div class="obligation-card">
              <div class="obligation-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
                </svg>
              </div>
              <h4>Publicité des Prix</h4>
              <p>Les prix doivent être portés à la connaissance des acheteurs de manière claire, que ce soit par étiquetage, affichage ou autre moyen approprié.</p>
            </div>
            
            <div class="obligation-card">
              <div class="obligation-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
                </svg>
              </div>
              <h4>Communication des Conditions de Vente</h4>
              <p>Tout professionnel doit pouvoir communiquer à un acheteur qui le demande son barème de prix et ses conditions de vente (délais de livraison, conditions de règlement, rabais, etc.).</p>
            </div>
          </div>
          
          <div class="expert-advice">
            <div class="advice-badge">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
              </svg>
              L'avis de l'expert
            </div>
            <p>Ces obligations renforcent le rôle central d'une comptabilité bien tenue. Un système de facturation fiable et un archivage rigoureux ne sont plus de simples tâches administratives, mais des impératifs légaux qui constituent la première ligne de défense en cas de contrôle.</p>
          </div>
        </div>
      </div>
      
      <div class="autorite-section">
        <div class="section-header">
          <div class="section-number">04</div>
          <div class="section-title-wrapper">
            <h2>Le Nouvel Arbitre du Marché : l'Autorité Nationale de la Concurrence</h2>
            <div class="section-underline"></div>
          </div>
        </div>
        
        <div class="autorite-content">
          <div class="autorite-intro-box">
            <div class="autorite-icon-large">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/>
              </svg>
            </div>
            <p>Pour veiller à l'application de cette loi, l'État crée une <strong>Autorité nationale de la concurrence</strong>. Cette institution indépendante sera le "gendarme" du marché.</p>
          </div>
          
          <div class="missions-grid">
            <div class="mission-card">
              <div class="mission-number">1</div>
              <h4>Surveillance</h4>
              <p>Surveiller les pratiques commerciales et le respect de la concurrence sur le marché</p>
            </div>
            
            <div class="mission-card">
              <div class="mission-number">2</div>
              <h4>Enquêtes</h4>
              <p>Enquêter sur les infractions et les pratiques anti-concurrentielles</p>
            </div>
            
            <div class="mission-card">
              <div class="mission-number">3</div>
              <h4>Avis & Conseil</h4>
              <p>Donner des avis sur les questions de concurrence et conseiller les entreprises</p>
            </div>
          </div>
          
          <div class="recours-info">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
            </svg>
            <p>Ses décisions pourront faire l'objet de recours devant la Cour suprême, garantissant ainsi un droit de défense aux entreprises.</p>
          </div>
        </div>
      </div>
      
      <div class="accompagnement-section">
        <div class="section-header success">
          <div class="section-number">05</div>
          <div class="section-title-wrapper">
            <h2>Comment Votre Expert-Comptable Vous Accompagne dans ce Nouveau Cadre</h2>
            <div class="section-underline success"></div>
          </div>
        </div>
        
        <div class="accompagnement-content">
          <p class="section-intro">Face à ces nouvelles règles, l'expert-comptable est plus que jamais votre conseiller stratégique. Notre rôle est de vous aider à naviguer en toute sécurité.</p>
          
          <div class="services-accordion">
            <div class="service-item">
              <div class="service-header">
                <div class="service-icon audit">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
                  </svg>
                </div>
                <h4>Audit de vos Pratiques Commerciales</h4>
              </div>
              <p>Nous pouvons analyser vos contrats (distribution, franchise, conditions générales de vente) pour nous assurer qu'ils ne contiennent pas de clauses abusives ou de clauses de non-concurrence interdites.</p>
            </div>
            
            <div class="service-item">
              <div class="service-header">
                <div class="service-icon prix">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"/>
                  </svg>
                </div>
                <h4>Structuration de vos Prix de Revient</h4>
              </div>
              <p>La loi interdit la vente à perte. Nous vous aidons à calculer précisément vos coûts d'achat effectifs pour fixer vos prix de vente en toute légalité et préserver vos marges.</p>
            </div>
            
            <div class="service-item">
              <div class="service-header">
                <div class="service-icon croissance">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"/>
                  </svg>
                </div>
                <h4>Accompagnement lors des Opérations de Croissance</h4>
              </div>
              <p>Tout projet de fusion ou d'acquisition est désormais soumis à une autorisation préalable. Nous vous accompagnons dans la préparation des dossiers financiers et la valorisation de votre entreprise, des étapes clés pour obtenir ces autorisations.</p>
            </div>
            
            <div class="service-item">
              <div class="service-header">
                <div class="service-icon procedures">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"/>
                  </svg>
                </div>
                <h4>Mise en Place de Procédures Internes</h4>
              </div>
              <p>Nous vous aidons à instaurer des procédures de facturation, d'archivage et de communication commerciale conformes à la loi, formant ainsi vos équipes aux bonnes pratiques.</p>
            </div>
          </div>
        </div>
      </div>
      
      <div class="conclusion-finale">
        <div class="conclusion-header">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
          <h2>Conclusion</h2>
        </div>
        
        <div class="conclusion-content">
          <p>Cette loi sur la concurrence n'a pas pour but de freiner l'initiative privée, mais au contraire de l'assainir pour permettre aux entreprises vertueuses de prospérer. <strong>La conformité n'est pas une charge, mais un investissement dans la pérennité et la réputation de votre entreprise.</strong></p>
          
          <p>N'attendez pas d'être confronté à un contrôle pour agir. C'est le moment idéal pour faire le point sur vos pratiques.</p>
          
          <div class="cta-finale">
            <h3>Passez à l'action dès maintenant</h3>
            <p>Contactez votre expert-comptable dès aujourd'hui pour un diagnostic complet et mettez votre entreprise sur la voie d'une croissance sécurisée et durable.</p>
          <button 
  class="btn-contact" 
  onclick="window.open('https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ30HiUAglAWfWtbsla-NeJVC3PrBwr9y2_8BzlRazyhV4YI0qYb89EJJ8l2yuCAzfRQ6-0hqkcK?gv=true', '_blank')"
>
  Demander un diagnostic
</button>
          </div>
        </div>
      </div>
      
      <div class="ressources-box">
        <h3>Pour lire l'intégralité de la loi et aller plus loin</h3>
        <ul>
          <li><a href="#" target="_blank">Loi N° 2025-02 du 05 février 2025</a></li>
          <li><a href="https://sgg.gouv.bj/" target="_blank">https://sgg.gouv.bj/</a></li>
        </ul>
        
        <div class="hashtags">
          <span>#CINEF</span>
          <span>#LoiConcurrence</span>
          <span>#Entreprise</span>
          <span>#Réglementation</span>
          <span>#ExpertComptable</span>
          <span>#Concurrence</span>
          <span>#BusinessBénin</span>
          <span>#Conformité</span>
          <span>#GestiondEntreprise</span>
          <span>#ConseilJuridique</span>
          <span>#Transparence</span>
          <span>#BonneGouvernance</span>
          <span>#OECCA-BENIN</span>
        </div>
      </div>
    `,
    categories: ["Réglementation", "Droit des Affaires", "Conformité"],
    tags: [
      "Loi Concurrence",
      "Bénin",
      "Réglementation",
      "Expert-Comptable",
      "Business",
      "Conformité",
      "Prix",
      "Transparence",
    ],
    date: "5 Février 2025",
    author: "Expert CINEF",
    authorTitle: "Expert-Comptable & Conseiller Stratégique",
    readTime: "15 min",
    featured: true,
  };

  const similarBlogs = [
    {
      id: 1,
      title: "Apports en Capital dans l'espace OHADA : Guide Complet",
      image: "/assets/images/image7.png",
      date: "10 octobre 2025",
      category: "Droit des Sociétés",
    },
    {
      id: 2,
      title: "Guide de la Fiscalité des Entreprises au Bénin",
      image: "/assets/images/image8.png",
      date: "28 septembre 2025",
      category: "Fiscalité",
    },
  ];

  return (
    <>
      <Header />
      <div className="blog-detail-page">
        <nav className="breadcrumb-nav">
          <div className="container">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link to="/">Accueil</Link>
              </li>
              <li className="breadcrumb-item">
                <Link to="/actualites/blog">Blog</Link>
              </li>
              <li className="breadcrumb-item active">Loi sur la Concurrence</li>
            </ol>
          </div>
        </nav>

        <div className="container blog-container">
          <div className="row">
            <div className="col-lg-8">
              <article className="blog-article">
                <div className="article-header">
                  <div className="categories-row">
                    {blogPost.categories.map((category, index) => (
                      <span key={index} className="cat-badge">
                        {category}
                      </span>
                    ))}
                  </div>

                  <h1 className="article-title">{blogPost.title}</h1>

                  <div className="article-meta">
                    <div className="meta-group">
                      <FaCalendarAlt className="icon" />
                      <span>{blogPost.date}</span>
                    </div>
                    <div className="meta-group">
                      <FaUser className="icon" />
                      <span>{blogPost.author}</span>
                    </div>
                    <div className="meta-group">
                      <FaClock className="icon" />
                      <span>{blogPost.readTime} de lecture</span>
                    </div>
                  </div>
                </div>

                <div className="article-excerpt">
                  <p>{blogPost.excerpt}</p>
                </div>

                <div
                  className="article-content"
                  dangerouslySetInnerHTML={{ __html: blogPost.content }}
                />

                <div className="article-footer">
                  <div className="tags-section">
                    <h5>Tags</h5>
                    <div className="tags-list">
                      {blogPost.tags.map((tag, index) => (
                        <Link key={index} to="#" className="tag-item">
                          #{tag}
                        </Link>
                      ))}
                    </div>
                  </div>

                  <div className="share-section">
                    <h5>Partager cet article</h5>
                    <div className="social-share">
                      <a href="#" className="share-btn linkedin">
                        <FaLinkedin />
                      </a>
                      <a href="#" className="share-btn twitter">
                        <FaTwitter />
                      </a>
                      <a href="#" className="share-btn facebook">
                        <FaFacebook />
                      </a>
                    </div>
                  </div>
                </div>

                <div className="navigation-section">
                  <Link to="/actualites/blog" className="back-btn">
                    <FaChevronLeft /> Retour au blog
                  </Link>
                </div>
              </article>
            </div>

            <div className="col-lg-4">
              <aside className="blog-sidebar">
                <div className="sidebar-card author-card">
                  <h4 className="card-title">À propos de l'auteur</h4>
                  <div className="author-info">
                    <div className="author-avatar">
                      <FaUser />
                    </div>
                    <h5>{blogPost.author}</h5>
                    <p className="author-role">{blogPost.authorTitle}</p>
                    <p className="author-bio">
                      Expert en réglementation des affaires et accompagnement
                      stratégique des entreprises dans l'espace OHADA.
                    </p>
                  </div>
                </div>

                <div className="sidebar-card related-card">
                  <h4 className="card-title">Articles similaires</h4>
                  <div className="related-posts">
                    {similarBlogs.map((blog) => (
                      <Link
                        key={blog.id}
                        to={`/blog/${blog.id}`}
                        className="related-post"
                      >
                        <div className="post-thumbnail">
                          <img src={blog.image} alt={blog.title} />
                          <span className="post-category">{blog.category}</span>
                        </div>
                        <div className="post-info">
                          <h6>{blog.title}</h6>
                          <div className="post-date">
                            <FaCalendarAlt size={12} />
                            <small>{blog.date}</small>
                          </div>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>

                <div className="sidebar-card newsletter-card">
                  <h4 className="card-title">Newsletter</h4>
                  <p>Recevez nos analyses juridiques et réglementaires</p>
                  <form className="newsletter-form">
                    <input type="email" placeholder="Votre email" required />
                    <button type="submit">S'inscrire</button>
                  </form>
                </div>

                <div className="sidebar-card resources-card">
                  <h4 className="card-title">Ressources utiles</h4>
                  <ul className="resources-list">
                    <li>
                      <a
                        href="https://sgg.gouv.bj/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Secrétariat Général du Gouvernement
                        <span>→</span>
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://oeccabenin.bj/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Ordre des Experts-Comptables
                        <span>→</span>
                      </a>
                    </li>
                    <li>
                      <Link to="/services">
                        Nos services
                        <span>→</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              </aside>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @import url("https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap");

        * {
          font-family: "Inter", -apple-system, BlinkMacSystemFont, sans-serif;
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .blog-detail-page {
          min-height: 100vh;
          padding: 2rem 0;
          max-width: 1400px;
          margin: 0 auto;
          width: 90%;
        }

        .breadcrumb-nav {
          background: white;
          padding: 1rem 0;
          margin-bottom: 2rem;
          border-bottom: 1px solid #e2e8f0;
          margin-top: 80px;
        }

        .breadcrumb {
          display: flex;
          list-style: none;
          padding: 0;
          margin: 0;
          font-size: 0.875rem;
        }

        .breadcrumb-item {
          color: #64748b;
        }

        .breadcrumb-item + .breadcrumb-item::before {
          content: "›";
          margin: 0 0.75rem;
          color: #94a3b8;
          font-size: 1.2rem;
        }

        .breadcrumb-item a {
          color: #475569;
          text-decoration: none;
          font-weight: 500;
          transition: color 0.2s;
        }

        .breadcrumb-item a:hover {
          color: #dc2626;
        }

        .breadcrumb-item.active {
          color: #1e293b;
          font-weight: 600;
        }

        .blog-container {
          max-width: 2000px;
        }

        .blog-article {
          background: white;
          border-radius: 20px;
          padding: 3rem;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
        }

        .article-header {
          margin-bottom: 2.5rem;
          padding-bottom: 2rem;
          border-bottom: 2px solid #f1f5f9;
        }

        .categories-row {
          display: flex;
          flex-wrap: wrap;
          gap: 0.75rem;
          margin-bottom: 1.5rem;
        }

        .cat-badge {
          background: linear-gradient(135deg, #dc2626 0%, #16a34a 100%);
          color: white;
          padding: 0.5rem 1.25rem;
          border-radius: 30px;
          font-size: 0.75rem;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.05em;
        }

        .article-title {
          font-size: 2.75rem;
          font-weight: 800;
          line-height: 1.2;
          color: #0f172a;
          margin-bottom: 1.5rem;
        }

        .article-meta {
          display: flex;
          flex-wrap: wrap;
          gap: 2rem;
        }

        .meta-group {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          color: #64748b;
          font-size: 0.9rem;
          font-weight: 500;
        }

        .meta-group .icon {
          color: #dc2626;
          font-size: 1.1rem;
        }

        .article-excerpt {
          background: linear-gradient(135deg, #fef2f2 0%, #f0fdf4 100%);
          border-left: 5px solid #dc2626;
          padding: 2rem;
          border-radius: 15px;
          margin-bottom: 3rem;
        }

        .article-excerpt p {
          font-size: 1.15rem;
          line-height: 1.8;
          color: #374151;
          margin: 0;
          font-weight: 500;
        }

        .article-content {
          font-size: 1.05rem;
          line-height: 1.8;
          color: #334155;
        }

        /* Styles du contenu */
        .hero-intro {
          background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
          padding: 2.5rem;
          border-radius: 20px;
          margin-bottom: 3rem;
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.06);
          border: 2px solid #e2e8f0;
        }

        .intro-icon {
          width: 70px;
          height: 70px;
          background: linear-gradient(135deg, #dc2626, #16a34a);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1.5rem;
        }

        .intro-icon svg {
          width: 40px;
          height: 40px;
          color: white;
        }

        .intro-lead {
          font-size: 1.2rem;
          font-weight: 600;
          line-height: 1.7;
          color: #1e293b;
          margin-bottom: 1.5rem;
        }

        .intro-emphasis {
          font-size: 1.15rem;
          font-weight: 600;
          color: #dc2626;
          text-align: center;
          margin-top: 1.5rem;
        }

        .principe-section,
        .interdictions-section,
        .transparence-section,
        .autorite-section,
        .accompagnement-section {
          margin: 4rem 0;
        }

        .section-header {
          display: flex;
          align-items: flex-start;
          gap: 2rem;
          margin-bottom: 2.5rem;
        }

        .section-number {
          background: linear-gradient(135deg, #3b82f6, #8b5cf6);
          color: white;
          width: 70px;
          height: 70px;
          border-radius: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 2rem;
          font-weight: 800;
          flex-shrink: 0;
          box-shadow: 0 8px 25px rgba(59, 130, 246, 0.3);
        }

        .section-header.danger .section-number {
          background: linear-gradient(135deg, #dc2626, #991b1b);
          box-shadow: 0 8px 25px rgba(220, 38, 38, 0.3);
        }

        .section-header.success .section-number {
          background: linear-gradient(135deg, #16a34a, #15803d);
          box-shadow: 0 8px 25px rgba(22, 163, 74, 0.3);
        }

        .section-title-wrapper {
          flex: 1;
        }

        .section-title-wrapper h2 {
          font-size: 2.25rem;
          font-weight: 800;
          color: #0f172a;
          margin-bottom: 0.75rem;
          line-height: 1.3;
        }

        .section-underline {
          width: 100px;
          height: 5px;
          background: linear-gradient(90deg, #3b82f6, #8b5cf6);
          border-radius: 10px;
        }

        .section-underline.danger {
          background: linear-gradient(90deg, #dc2626, #991b1b);
        }

        .section-underline.success {
          background: linear-gradient(90deg, #16a34a, #15803d);
        }

        .principe-intro,
        .section-intro {
          font-size: 1.1rem;
          line-height: 1.8;
          color: #475569;
          margin-bottom: 2rem;
        }

        .intervention-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 1.5rem;
          margin: 2rem 0;
        }

        .intervention-card {
          background: white;
          padding: 2rem;
          border-radius: 15px;
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
          border: 2px solid #e2e8f0;
          transition: all 0.3s ease;
        }

        .intervention-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
          border-color: #3b82f6;
        }

        .card-icon {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 1.5rem;
        }

        .card-icon.strategic {
          background: linear-gradient(135deg, #3b82f6, #2563eb);
        }

        .card-icon.monopole {
          background: linear-gradient(135deg, #8b5cf6, #7c3aed);
        }

        .card-icon.crise {
          background: linear-gradient(135deg, #f59e0b, #d97706);
        }

        .card-icon svg {
          width: 30px;
          height: 30px;
          color: white;
        }

        .intervention-card h4 {
          font-size: 1.25rem;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 0.75rem;
        }

        .intervention-card p {
          color: #64748b;
          line-height: 1.7;
        }

        .expert-advice {
          background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
          border-left: 5px solid #f59e0b;
          padding: 2rem;
          border-radius: 15px;
          margin-top: 2rem;
        }

        .advice-badge {
          display: inline-flex;
          align-items: center;
          gap: 0.75rem;
          background: #92400e;
          color: white;
          padding: 0.5rem 1.25rem;
          border-radius: 30px;
          font-weight: 700;
          font-size: 0.9rem;
          margin-bottom: 1rem;
        }

        .advice-badge svg {
          width: 20px;
          height: 20px;
        }

        .expert-advice p {
          color: #78350f;
          font-weight: 500;
          line-height: 1.7;
          margin: 0;
        }

        .interdiction-list {
          display: flex;
          flex-direction: column;
          gap: 2rem;
          margin-top: 2rem;
        }

        .interdiction-item {
          background: white;
          padding: 2rem;
          border-radius: 15px;
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
          border-left: 5px solid #dc2626;
        }

        .interdiction-header {
          display: flex;
          align-items: center;
          gap: 1.5rem;
          margin-bottom: 1rem;
        }

        .interdiction-icon {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .interdiction-icon.entente {
          background: linear-gradient(135deg, #dc2626, #991b1b);
        }

        .interdiction-icon.abus {
          background: linear-gradient(135deg, #ea580c, #c2410c);
        }

        .interdiction-icon.deloyale {
          background: linear-gradient(135deg, #f59e0b, #d97706);
        }

        .interdiction-icon svg {
          width: 25px;
          height: 25px;
          color: white;
        }

        .interdiction-header h3 {
          font-size: 1.5rem;
          font-weight: 700;
          color: #1e293b;
          margin: 0;
        }

        .interdiction-item p {
          color: #475569;
          line-height: 1.7;
          margin: 0;
        }

        .deloyale-list {
          list-style: none;
          padding-left: 0;
          margin-top: 1rem;
        }

        .deloyale-list li {
          padding-left: 2rem;
          position: relative;
          margin-bottom: 0.75rem;
          color: #475569;
          line-height: 1.7;
        }

        .deloyale-list li::before {
          content: "●";
          position: absolute;
          left: 0.5rem;
          color: #dc2626;
          font-size: 1.2rem;
        }

        .obligations-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
          gap: 1.5rem;
          margin: 2rem 0;
        }

        .obligation-card {
          background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
          padding: 2rem;
          border-radius: 15px;
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.06);
          border: 2px solid #e2e8f0;
          transition: all 0.3s ease;
        }

        .obligation-card.highlight {
          background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%);
          border-color: #fca5a5;
        }

        .obligation-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
        }

        .obligation-icon {
          width: 55px;
          height: 55px;
          background: linear-gradient(135deg, #3b82f6, #2563eb);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 1.25rem;
        }

        .obligation-icon svg {
          width: 28px;
          height: 28px;
          color: white;
        }

        .obligation-card h4 {
          font-size: 1.2rem;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 0.75rem;
        }

        .obligation-card p {
          color: #475569;
          line-height: 1.7;
          margin: 0;
          font-size: 0.95rem;
        }

        .autorite-intro-box {
          background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
          padding: 2.5rem;
          border-radius: 20px;
          text-align: center;
          margin-bottom: 2.5rem;
          border: 2px solid #93c5fd;
        }

        .autorite-icon-large {
          width: 80px;
          height: 80px;
          background: linear-gradient(135deg, #3b82f6, #1d4ed8);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1.5rem;
          box-shadow: 0 10px 30px rgba(59, 130, 246, 0.3);
        }

        .autorite-icon-large svg {
          width: 45px;
          height: 45px;
          color: white;
        }

        .autorite-intro-box p {
          font-size: 1.15rem;
          color: #1e40af;
          font-weight: 500;
          line-height: 1.7;
          margin: 0;
        }

        .missions-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          gap: 1.5rem;
          margin: 2rem 0;
        }

        .mission-card {
          background: white;
          padding: 2rem;
          border-radius: 15px;
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.06);
          border: 2px solid #e2e8f0;
          position: relative;
          overflow: hidden;
          transition: all 0.3s ease;
        }

        .mission-card::before {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 5px;
          background: linear-gradient(90deg, #3b82f6, #8b5cf6);
        }

        .mission-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.12);
        }

        .mission-number {
          width: 45px;
          height: 45px;
          background: linear-gradient(135deg, #3b82f6, #8b5cf6);
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 1.5rem;
          font-weight: 800;
          margin-bottom: 1.25rem;
        }

        .mission-card h4 {
          font-size: 1.25rem;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 0.75rem;
        }

        .mission-card p {
          color: #64748b;
          line-height: 1.7;
          margin: 0;
        }

        .recours-info {
          background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
          padding: 1.5rem 2rem;
          border-radius: 15px;
          display: flex;
          align-items: flex-start;
          gap: 1rem;
          margin-top: 2rem;
          border: 2px solid #bae6fd;
        }

        .recours-info svg {
          width: 24px;
          height: 24px;
          color: #0284c7;
          flex-shrink: 0;
          margin-top: 0.25rem;
        }

        .recours-info p {
          color: #0c4a6e;
          font-weight: 500;
          line-height: 1.7;
          margin: 0;
        }

        .services-accordion {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
          margin-top: 2rem;
        }

        .service-item {
          background: white;
          padding: 2rem;
          border-radius: 15px;
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.06);
          border: 2px solid #e2e8f0;
          transition: all 0.3s ease;
        }

        .service-item:hover {
          border-color: #16a34a;
          box-shadow: 0 8px 25px rgba(22, 163, 74, 0.15);
        }

        .service-header {
          display: flex;
          align-items: center;
          gap: 1.5rem;
          margin-bottom: 1rem;
        }

        .service-icon {
          width: 55px;
          height: 55px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .service-icon.audit {
          background: linear-gradient(135deg, #16a34a, #15803d);
        }

        .service-icon.prix {
          background: linear-gradient(135deg, #0891b2, #0e7490);
        }

        .service-icon.croissance {
          background: linear-gradient(135deg, #8b5cf6, #7c3aed);
        }

        .service-icon.procedures {
          background: linear-gradient(135deg, #f59e0b, #d97706);
        }

        .service-icon svg {
          width: 28px;
          height: 28px;
          color: white;
        }

        .service-header h4 {
          font-size: 1.35rem;
          font-weight: 700;
          color: #1e293b;
          margin: 0;
        }

        .service-item p {
          color: #475569;
          line-height: 1.7;
          margin: 0;
        }

        .conclusion-finale {
          background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
          padding: 3rem;
          border-radius: 20px;
          margin: 4rem 0;
          border: 2px solid #86efac;
        }

        .conclusion-header {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 1rem;
          margin-bottom: 2rem;
        }

        .conclusion-header svg {
          width: 50px;
          height: 50px;
          color: #16a34a;
        }

        .conclusion-header h2 {
          font-size: 2.5rem;
          font-weight: 800;
          color: #14532d;
          margin: 0;
        }

        .conclusion-content p {
          font-size: 1.1rem;
          line-height: 1.8;
          color: #166534;
          margin-bottom: 1.5rem;
        }

        .cta-finale {
          background: white;
          padding: 2.5rem;
          border-radius: 15px;
          text-align: center;
          margin-top: 2rem;
          box-shadow: 0 8px 25px rgba(22, 163, 74, 0.15);
        }

        .cta-finale h3 {
          font-size: 1.75rem;
          font-weight: 800;
          color: #0f172a;
          margin-bottom: 1rem;
        }

        .cta-finale p {
          font-size: 1.05rem;
          color: #475569;
          margin-bottom: 1.5rem;
        }

        .btn-contact {
          background: linear-gradient(135deg, #dc2626, #16a34a);
          color: white;
          border: none;
          padding: 1rem 2.5rem;
          font-size: 1.1rem;
          font-weight: 700;
          border-radius: 50px;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 5px 20px rgba(220, 38, 38, 0.3);
        }

        .btn-contact:hover {
          transform: translateY(-3px);
          box-shadow: 0 8px 30px rgba(220, 38, 38, 0.4);
        }

        .ressources-box {
          background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
          padding: 2.5rem;
          border-radius: 20px;
          margin-top: 3rem;
          border: 2px solid #cbd5e1;
        }

        .ressources-box h3 {
          font-size: 1.5rem;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 1.5rem;
        }

        .ressources-box ul {
          list-style: none;
          padding: 0;
          margin-bottom: 2rem;
        }

        .ressources-box li {
          margin-bottom: 0.75rem;
        }

        .ressources-box a {
          color: #2563eb;
          text-decoration: none;
          font-weight: 600;
          transition: color 0.2s;
        }

        .ressources-box a:hover {
          color: #1e40af;
          text-decoration: underline;
        }

        .hashtags {
          display: flex;
          flex-wrap: wrap;
          gap: 0.75rem;
          margin-top: 1.5rem;
        }

        .hashtags span {
          background: white;
          color: #3b82f6;
          padding: 0.5rem 1rem;
          border-radius: 25px;
          font-size: 0.85rem;
          font-weight: 600;
          border: 2px solid #3b82f6;
          transition: all 0.2s;
          cursor: pointer;
        }

        .hashtags span:hover {
          background: #3b82f6;
          color: white;
        }

        .article-footer {
          margin-top: 3rem;
          padding-top: 2rem;
          border-top: 2px solid #f1f5f9;
        }

        .tags-section {
          margin-bottom: 2rem;
        }

        .tags-section h5 {
          font-size: 1.25rem;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 1rem;
        }

        .tags-list {
          display: flex;
          flex-wrap: wrap;
          gap: 0.75rem;
        }

        .tag-item {
          background: #f1f5f9;
          color: #475569;
          padding: 0.5rem 1.25rem;
          border-radius: 25px;
          font-size: 0.9rem;
          font-weight: 600;
          text-decoration: none;
          transition: all 0.2s;
        }

        .tag-item:hover {
          background: #dc2626;
          color: white;
        }

        .share-section h5 {
          font-size: 1.25rem;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 1rem;
        }

        .social-share {
          display: flex;
          gap: 1rem;
        }

        .share-btn {
          width: 50px;
          height: 50px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 1.5rem;
          text-decoration: none;
          transition: all 0.3s ease;
        }

        .share-btn.linkedin {
          background: #0a66c2;
        }

        .share-btn.twitter {
          background: #1da1f2;
        }

        .share-btn.facebook {
          background: #1877f2;
        }

        .share-btn:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
        }

        .navigation-section {
          margin-top: 3rem;
        }

        .back-btn {
          display: inline-flex;
          align-items: center;
          gap: 0.75rem;
          background: #f1f5f9;
          color: #475569;
          padding: 0.75rem 1.75rem;
          border-radius: 30px;
          font-weight: 600;
          text-decoration: none;
          transition: all 0.3s ease;
        }

        .back-btn:hover {
          background: #dc2626;
          color: white;
          transform: translateX(-5px);
        }

        .blog-sidebar {
          position: sticky;
          top: 2rem;
        }

        .sidebar-card {
          background: white;
          padding: 2rem;
          border-radius: 20px;
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
          margin-bottom: 2rem;
        }

        .card-title {
          font-size: 1.35rem;
          font-weight: 800;
          color: #0f172a;
          margin-bottom: 1.5rem;
          padding-bottom: 0.75rem;
          border-bottom: 3px solid #dc2626;
        }

        .author-info {
          text-align: center;
        }

        .author-avatar {
          width: 90px;
          height: 90px;
          background: linear-gradient(135deg, #3b82f6, #8b5cf6);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1.5rem;
          border: 4px solid #e0f2fe;
        }

        .author-avatar svg {
          width: 45px;
          height: 45px;
          color: white;
        }

        .author-info h5 {
          font-size: 1.25rem;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 0.5rem;
        }

        .author-role {
          color: #64748b;
          font-size: 0.95rem;
          font-weight: 600;
          margin-bottom: 1rem;
        }

        .author-bio {
          color: #475569;
          font-size: 0.9rem;
          line-height: 1.6;
        }

        .related-posts {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }

        .related-post {
          display: flex;
          gap: 1rem;
          text-decoration: none;
          color: inherit;
          transition: all 0.3s ease;
          padding: 0.75rem;
          border-radius: 12px;
        }

        .related-post:hover {
          background: #f8fafc;
        }

        .post-thumbnail {
          position: relative;
          flex-shrink: 0;
        }

        .post-thumbnail img {
          width: 100px;
          height: 100px;
          object-fit: cover;
          border-radius: 12px;
        }

        .post-category {
          position: absolute;
          top: 8px;
          left: 8px;
          background: linear-gradient(135deg, #dc2626, #16a34a);
          color: white;
          padding: 0.3rem 0.75rem;
          border-radius: 20px;
          font-size: 0.7rem;
          font-weight: 700;
        }

        .post-info h6 {
          font-size: 1rem;
          font-weight: 600;
          color: #1e293b;
          margin-bottom: 0.5rem;
          line-height: 1.4;
        }

        .post-date {
          display: flex;
          align-items: center;
          gap: 0.5rem;
          color: #64748b;
          font-size: 0.85rem;
        }

        .post-date svg {
          color: #dc2626;
        }

        .newsletter-card p {
          color: #475569;
          font-size: 0.95rem;
          line-height: 1.6;
          margin-bottom: 1.5rem;
        }

        .newsletter-form {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .newsletter-form input {
          padding: 0.875rem 1.25rem;
          border: 2px solid #e2e8f0;
          border-radius: 30px;
          font-size: 0.95rem;
          transition: all 0.3s ease;
        }

        .newsletter-form input:focus {
          outline: none;
          border-color: #3b82f6;
          box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
        }

        .newsletter-form button {
          background: linear-gradient(135deg, #dc2626, #16a34a);
          color: white;
          border: none;
          padding: 0.875rem;
          border-radius: 30px;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .newsletter-form button:hover {
          transform: translateY(-2px);
          box-shadow: 0 5px 20px rgba(220, 38, 38, 0.3);
        }

        .resources-list {
          list-style: none;
          padding: 0;
        }

        .resources-list li {
          margin-bottom: 1rem;
        }

        .resources-list a {
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #2563eb;
          text-decoration: none;
          font-weight: 600;
          padding: 0.75rem;
          border-radius: 10px;
          transition: all 0.2s;
        }

        .resources-list a:hover {
          background: #eff6ff;
          color: #1e40af;
        }

        .resources-list a span {
          font-size: 1.25rem;
          font-weight: 700;
        }

        @media (max-width: 991px) {
          .blog-sidebar {
            position: static;
            margin-top: 3rem;
          }
        }

        @media (max-width: 767px) {
          .blog-article {
            padding: 2rem 1.5rem;
          }

          .article-title {
            font-size: 2rem;
          }

          .section-header {
            flex-direction: column;
            align-items: flex-start;
          }

          .section-number {
            width: 60px;
            height: 60px;
            font-size: 1.75rem;
          }

          .section-title-wrapper h2 {
            font-size: 1.75rem;
          }

          .intervention-grid,
          .obligations-grid,
          .missions-grid {
            grid-template-columns: 1fr;
          }

          .article-meta {
            gap: 1rem;
          }

          .conclusion-header {
            flex-direction: column;
          }

          .conclusion-header h2 {
            font-size: 2rem;
            text-align: center;
          }

          .hashtags span {
            font-size: 0.75rem;
            padding: 0.4rem 0.75rem;
          }
        }
      `}</style>
      <Footer />
    </>
  );
};

export default DetailBlog13;
